type TNudgePrimingMessageType = 'eya' | 'incorrectAnswer' | 'stumped'

export type TTutorState = {
    chat: {
        role: 'user' | 'assistant' | 'system' | 'tool_use'
        content: string
        isStreaming?: boolean
    }[]
    textbookSearch: {
        isLoading: boolean
        error?: string
        results: {
            citation: string
            explanation: string
        }[]
    }
    isLoadingSessionHistory: boolean
    isTutorResponding: boolean
    isChatOpen: boolean
    cost: number
    hasInteractedWithTutorChat: boolean
    hasOpenedChatDuringQuiz: boolean
    greetingQuestionIndex: number | null
    nudgePrimingMessageType: TNudgePrimingMessageType | null
    rating: number
    hasSentTutorMessageDuringQuiz: boolean
    tutorNameTestVariantLabel?: string
}

export const getInitialTutorState = (): TTutorState => {
    return {
        chat: [],
        textbookSearch: { isLoading: false, results: [] },
        isLoadingSessionHistory: false,
        isChatOpen: false,
        isTutorResponding: false,
        cost: 0,
        hasInteractedWithTutorChat: false,
        hasOpenedChatDuringQuiz: false,
        greetingQuestionIndex: null,
        nudgePrimingMessageType: null,
        rating: 0,
        hasSentTutorMessageDuringQuiz: false,
    }
}

const moduleState = getInitialTutorState()

export default moduleState
